import React from 'react';
import ReactDom from 'react-dom';
import {Column} from "primereact/column";
import { DataTable } from 'primereact/datatable';
import Pagination from "react-js-pagination";
import {Accordion, AccordionTab} from "primereact/accordion";
import {Dropdown} from "primereact/dropdown";
import {InputSwitch} from "primereact/inputswitch";
import DatePicker, {registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InnerLoading from "../RelatorioRevendaLocacao/InnerLoading";
import AsyncSelect from 'react-select/async';

class LogAcessoAPI extends React.Component{

    constructor(props) {
        super(props);

        this.state = {
            activeIndex: 0,
            logs: [],
            companies: [],
            filters: {
                ...this.initialFilters
            },
            loading: false,
            pagination: {
                current_page: 1, per_page: 10, total: 0, from: 0, to: 0
            },
        };

        this.collumns = [
            { field: 'user_name', header: 'Usuário' },
            { field: 'company_name', header: 'Empresa' },
            { field: 'url', header: 'URL' },
            { field: 'created_at_formatted', header: 'Data' },
            { field: 'ip_address', header: 'Endereço IP' },
        ];
    }

    initialFilters = {
        data_maior_que: '',
        data_menor_que: '',
        company_id: ''
    }

    componentDidMount = async ()=>{
        await Promise.all([
            this.getLogs(),
            this.getCompanies()
        ]);
    }

    getCompanies = async()=>{
        try{
            await this.setLoading(true);
            let response = await axios.get(route('companies.list'));

            if( response.status === 200 ){
                this.setState({
                    ...this.state,
                    companies: response.data.companies
                })
            }
        }catch (e){
            console.log(e);
        }finally {
            await this.setLoading(false);
        }
    }

    setLoading = (loading) => {
        this.setState({
            loading: loading
        });
    }

    getLogs = async () => {
        try {
            await this.setLoading(true);

            const requestPayload = this.getRequestPayload();

            console.log( requestPayload );

            let requestExtraParams = {};

            if( this.state.filters.export_excel ){
                requestExtraParams.responseType = 'blob';
            }

            const response = await axios.get( route('logacesso_api.index', requestPayload ), requestExtraParams );

            if( response.headers['content-type'] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ){
                this.handleDownloadExcel(response);
                return;
            }

            if (response.status === 200) {
                this.setState({
                    ...this.state,
                    logs: response.data.data,
                    pagination: {
                        current_page: response.data.current_page,
                        last_page: response.data.last_page,
                        total: response.data.total,
                        per_page: response.data.per_page,
                        from: response.data.from,
                        to: response.data.to,
                    },
                });
            }

        }catch (e) {
            console.log(e);
        }finally {
            await this.setLoading(false);
        }
    }

    getRequestPayload = () => {
        return {
            page: this.state.pagination.current_page || 1,
            export_excel: this.state.filters.export_excel || false,
            user_id: this.state.filters.user ? this.state.filters.user.value : '',
            data_maior_que: this.state.filters.data_maior_que ? this.state.filters.data_maior_que : '',
            data_menor_que: this.state.filters.data_menor_que ? this.state.filters.data_menor_que : '',
            empresa_id: this.state.filters.company_id,
        };
    }

    handleDownloadExcel(response) {
        const type = response.headers['content-type']
        const blob = new Blob([response.data], {type: type, encoding: 'UTF-8'})
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = response.headers['content-disposition'].split(';')[1].split('=')[1];
        link.click()

        this.setState({
            ...this.state,
            filters: {
                ...this.state.filters,
                export_excel: false
            }
        });

    }

    handlePageChange = async (pageNumber) => {
        await this.setState({
            ...this.state, pagination: {
                ...this.state.pagination, current_page: pageNumber
            }
        });

        await this.getLogs();
    }

    clearFilters = async (e) => {
        e.preventDefault();

        await this.setState({
            ...this.state, filters: {
                ...this.initialFilters,
            }
        });

        await this.getLogs();
    }

    searchCliente = async (inputQuery) => {
        if (inputQuery.length >= 2) {
            const response = await axios.get('/search-clients/' + inputQuery);
            return  response.data;

        }
    }




    render(){

        const dynamicColumns = this.collumns.map((col,i) => {
            return <Column key={col.field} field={col.field} header={col.header} />;
        });

        return (
            <div>
                <div>
                    <Accordion activeIndex={this.state.activeIndex}
                               onTabChange={(e) => this.setState({activeIndex: e.index})}>
                        <AccordionTab header="Busca">
                            <div>
                                <div className="form-group row">
                                    <div className="col-12 col-md-6 col-sm-6">
                                        <label htmlFor="">Usuário</label>
                                        <AsyncSelect
                                                cacheOptions
                                                isClearable
                                                placeholder="Digite para buscar..."
                                                noOptionsMessage={() => 'Nenhum Resultado'}
                                                value={this.state.filters.user}
                                                loadOptions={this.searchCliente}
                                                onChange={async (e) => {
                                                    await this.setState({
                                                        ...this.state,
                                                        filters: {
                                                            ...this.state.filters,
                                                            user: e
                                                        }
                                                    });
                                                }}
                                            />

                                    </div>

                                    <div className="col-12 col-md-6 col-sm-6">
                                        <label htmlFor="">Empresa</label> <br/>

                                        <Dropdown
                                            filter
                                            value={this.state.filters.company_id}
                                            options={this.state.companies}
                                            onChange={(e) => {
                                                this.setState({
                                                    ...this.state,
                                                    filters: {
                                                        ...this.state.filters,
                                                        company_id: e.value
                                                    }
                                                });
                                            }
                                            }
                                            style={{width: '100%'}}
                                            placeholder="Selecione uma empresa"/>



                                    </div>
                                </div>

                                <div className="form-group row">
                                    <div className="col-12 col-md-6 col-sm-6">
                                        <label htmlFor="">Data Maior Que</label>
                                        <DatePicker
                                            locale="pt-BR"
                                            className="form-control"
                                            dateFormat="dd/MM/yyyy"
                                            selected={this.state.filters.data_maior_que}
                                            onChange={async (e) => {
                                                await this.setState({
                                                    ...this.state, filters: {
                                                        ...this.state.filters, data_maior_que: e
                                                    }
                                                });
                                            }}
                                        />
                                    </div>

                                    <div className="col-12 col-md-6 col-sm-6">
                                        <label htmlFor="">Data Menor Que</label>
                                        <DatePicker
                                            locale="pt-BR"
                                            className="form-control"
                                            dateFormat="dd/MM/yyyy"
                                            selected={this.state.filters.data_menor_que}
                                            onChange={async (e) => {
                                                await this.setState({
                                                    ...this.state, filters: {
                                                        ...this.state.filters, data_menor_que: e
                                                    }
                                                });
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <div className="col-12 col-md-4 col-sm-4">
                                        <button className="btn btn-block btn-sm btn-success" onClick={async () => {
                                            await this.setState({
                                                ...this.state, pagination: {
                                                    ...this.state.pagination, current_page: 1
                                                }
                                            });

                                            await this.getLogs();
                                        }}>
                                            Pesquisar
                                        </button>
                                    </div>
                                    <div className="col-12 col-md-4 col-sm-4">
                                        <button className="btn btn-block btn-sm btn-secondary" onClick={async () => {
                                            await this.setState({
                                                ...this.state,
                                                filters: {
                                                    ...this.state.filters,
                                                    export_excel: true,
                                                },
                                                pagination: {
                                                    ...this.state.pagination, current_page: 1
                                                }
                                            });

                                            await this.getLogs();
                                        }}>
                                            Exportar Excel &nbsp;
                                            <i className="fa fa-file-excel-o"></i>

                                        </button>
                                    </div>

                                    <div className="col-12 col-md-4 col-sm-4">
                                        <button className="btn btn-block btn-sm btn-danger" onClick={this.clearFilters}>
                                            Limpar Filtros
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </AccordionTab>
                    </Accordion>


                </div>

                <div className="mb-10">
                    {this.state.loading && <InnerLoading/>}

                    {!this.state.loading && <p className="small text-muted" style={{padding: '10px'}}>
                        Exibindo resultados de {this.state.pagination.from} até {this.state.pagination.to} de um total
                        de {Number(this.state.pagination.total).toLocaleString()} registros.
                    </p>

                    }
                    <DataTable value={this.state.logs} scrollable={true} className="p-datatable-striped">
                        {dynamicColumns}
                    </DataTable>

                    <hr/>
                    <div className="d-flex justify-content-center">
                        <Pagination
                            activePage={this.state.pagination.current_page}
                            itemsCountPerPage={this.state.pagination.per_page}
                            totalItemsCount={this.state.pagination.total}
                            pageRangeDisplayed={10}
                            onChange={this.handlePageChange}
                            itemClass="page-item"
                            linkClass="page-link"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

if (document.getElementById('js-lista-acesso-api')) {
    ReactDom.render(<LogAcessoAPI/>, document.getElementById('js-lista-acesso-api'));
}




